import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            {/*<Route path="/features" element={<Features />} />*/}
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <footer className="site-footer">
          <Link to="/privacy">Privacy Policy</Link>
          <div className="footer-copy">&copy; {new Date().getFullYear()} FireTechAi, Inc.</div>
        </footer>
      </div>
    </Router>
  );
}

export default App;